import { WaveBlockKind } from "@vida/wave-core";

const BLOCK_MENU: { kind: WaveBlockKind; label: string }[] = [
  { kind: WaveBlockKind.Text, label: "Testo" },
  { kind: WaveBlockKind.Heading, label: "Titolo" },
  { kind: WaveBlockKind.Decision, label: "Decisione" },
  { kind: WaveBlockKind.Signoff, label: "Sign-off" },
  { kind: WaveBlockKind.Poll, label: "Sondaggio" },
  { kind: WaveBlockKind.TodoList, label: "Lista todo" },
  { kind: WaveBlockKind.Gallery, label: "Galleria" },
  { kind: WaveBlockKind.TidePageRef, label: "Tide" },
  { kind: WaveBlockKind.DriftTodoRef, label: "Drift" },
  { kind: WaveBlockKind.ReefArticleRef, label: "Reef" },
  { kind: WaveBlockKind.PulseDocRef, label: "Pulse" },
  { kind: WaveBlockKind.File, label: "File" },
];

type Props = {
  onInsert: (kind: WaveBlockKind) => void;
};

export function WaveCommandBar({ onInsert }: Props) {
  return (
    <div className="command-bar">
      {BLOCK_MENU.map(({ kind, label }) => (
        <button key={kind} type="button" onClick={() => onInsert(kind)}>
          /{label.toLowerCase()}
        </button>
      ))}
    </div>
  );
}

type FabProps = {
  commandText: string;
  onCommandChange: (v: string) => void;
  onAddPlainText: () => void;
  onAddAssistant: () => void;
  onPickFile: () => void;
  onInsertBlock: (kind: WaveBlockKind) => void;
  busy?: boolean;
};

export function WaveAddFAB({
  commandText,
  onCommandChange,
  onAddPlainText,
  onAddAssistant,
  onPickFile,
  onInsertBlock,
  busy = false,
}: FabProps) {
  return (
    <div className="wave-fab">
      <input
        value={commandText}
        disabled={busy}
        placeholder="/ comando, @assistente o @documenti: …"
        onChange={(e) => onCommandChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (commandText.includes("@documenti:") || commandText.includes("@assistente")) {
              onAddAssistant();
            } else {
              onAddPlainText();
            }
          }
        }}
      />
      <details>
        <summary>+</summary>
        <div className="fab-menu">
          <button type="button" onClick={onPickFile}>
            File
          </button>
          {BLOCK_MENU.filter(({ kind }) => kind !== WaveBlockKind.File).map(({ kind, label }) => (
            <button key={kind} type="button" onClick={() => onInsertBlock(kind)}>
              {label}
            </button>
          ))}
        </div>
      </details>
    </div>
  );
}
